module.exports = __webpack_public_path__ + "img/unsettled.2db31640.svg";